// @dynamic-i18n-keys
// Dynamic t() at line 35: key from textKeyForDeviationType(getDeviationType(deviation)).
//   deviationview.paywall.artstage.watchersOnly.text.literature
//   deviationview.paywall.artstage.watchersOnly.text.video
//   deviationview.paywall.artstage.watchersOnly.text
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PaywallProps } from './types';
import PaywallLayout from './PaywallLayout';
import { getDeviationType } from '../../../_helpers';
import { DeviationTypes } from '../../../../types/deviation';
import { ProfileOwnerWatchButton } from '../../../../Button';

import { navigateToSanitizedUrl } from '@wix/da-url';

import paywallStyles from './Paywall.scss';

const textKeyForDeviationType = (type: DeviationTypes) => {
  if (type === DeviationTypes.LITERATURE) {
    return 'deviationview.paywall.artstage.watchersOnly.text.literature';
  }

  if (type === DeviationTypes.FILM) {
    return 'deviationview.paywall.artstage.watchersOnly.text.video';
  }

  return 'deviationview.paywall.artstage.watchersOnly.text';
};

const WatchersOnlyPaywall: React.FC<PaywallProps> = ({
  deviation: { author },
  deviation,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <PaywallLayout
      deviation={deviation}
      icon={<div className={paywallStyles['watchers-icon']} />}
      title={t('deviationview.paywall.artstage.watchersOnly.title')}
      text={t(textKeyForDeviationType(getDeviationType(deviation)))}
      button={
        author && (
          <ProfileOwnerWatchButton
            className={paywallStyles['watch-button']}
            user={author}
            onToggleWatchSuccess={() => {
              navigateToSanitizedUrl(deviation.url!);
            }}
          />
        )
      }
      {...props}
    />
  );
};
WatchersOnlyPaywall.displayName = 'WatchersOnlyPaywall';

export default WatchersOnlyPaywall;
